module.exports = __webpack_public_path__ + "static/media/arrow-up.7c9f1627.svg";